import { render, staticRenderFns } from "./AcctRec.vue?vue&type=template&id=7789dd84&lang=pug&"
import script from "./AcctRec.vue?vue&type=script&lang=js&"
export * from "./AcctRec.vue?vue&type=script&lang=js&"
import style0 from "./AcctRec.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports